// contact widget
$(function() {
    $('.m-toolbar-default-index__wrapper_icon').on('mouseover', function () {
        $('.m-toolbar-default-index').toggleClass('open');
    });
});
